export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () =>
      import(
        /* webpackChunkName: "dashboard" */ '@/modules/dashboard/_views/HomeDashboard'
      ),
    meta: {
      section: 'dashboard',
      allowedRoles: [
        'ROLE_SUPER_ADMIN',
        'ROLE_COMMERCIAL',
        'ROLE_ADMIN',
        'ROLE_ADMIN_OWNER',
        'ROLE_ACCOUNT_HOLDER',
        'ROLE_REGULAR',
        'ROLE_BOOKKEEPER',
        'ROLE_SUPER_BOOKKEEPER'
      ]
    }
  }
]
